import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { noop } from 'lodash';
export default class GenericStore {
  constructor() {
    _defineProperty(this, "internalState", void 0);

    _defineProperty(this, "listeners", new Set());

    _defineProperty(this, "subscribe", listener => {
      this.listeners.add(listener);
      return () => {
        this.listeners.delete(listener);
      };
    });
  }

  set state(state) {
    this.internalState = state;
    this.broadcast();
  }

  get state() {
    return this.internalState;
  }

  broadcast() {
    this.listeners.forEach(listener => listener());
  }

}
export const createDummyStore = value => ({
  state: value,

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subscribe(_) {
    return noop;
  }

});